module.exports = __webpack_public_path__ + "components/Map/graphics/tree-nursery-pin.135b18ccd4118a4941c140ea56210126.png";